import React, { useEffect, useState } from "react";
import axios from "axios";
import { backend_url } from "../App";
import "./CSS/varietyAccessories.css";
import { menuItems } from "../Constants/menuItems";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MediaField from "../Components/MediaField/MediaField";
import DownloadButton from "../Components/MediaField/DownloadButton";
import { MAX_IMAGE_MB } from "../utils/media";

const DesignPatterns = () => {
    const [designPatterns, setDesignPatterns] = useState([]);
    const [formData, setFormData] = useState({
        collectionName: "",
        category: "",
        routeTo: "",
        image: null,
        placeTo: "",
        startingFrom: 0
    });

    const [selectedCategory, setSelectedCategory] = useState("");
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [existingImage, setExistingImage] = useState("");

    const allPlaces = ["Place 1", "Place 2", "Place 3", "Place 4", "Place 5"];

    const placeImages = {
        "Place 1": "/images/DesignPattern-1.png",
        "Place 2": "/images/DesignPattern-2.png",
        "Place 3": "/images/DesignPattern-3.png",
        "Place 4": "/images/DesignPattern-4.png",
        "Place 5": "/images/DesignPattern-5.png"
    };

    // Fetch all varieties
    useEffect(() => {
        fetchDesignPatterns();
    }, []);

    const fetchDesignPatterns = async () => {
        try {
            const response = await axios.get(`${backend_url}/api/designpatterns`);
            setDesignPatterns(response.data);
        } catch (error) {
            console.error("Error fetching patterns:", error);
        }
    };


    const availablePlaces = designPatterns
        ? allPlaces.filter(
            (place) =>
                !designPatterns.some((pattern) => pattern.placeTo === place) ||
                place === formData.placeTo
        )
        : allPlaces;



    // Handle form input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle category change and filter route options
    const handleCategoryChange = (e) => {
        const selected = e.target.value;
        setSelectedCategory(selected);
        setFormData({ ...formData, category: selected });

        if (selected) {
            const selectedCategory = menuItems.find((item) => item.value === selected);

            if (selectedCategory && selectedCategory.dropdown) {
                // Flatten dropdown and subcategories
                const options = selectedCategory.dropdown.flatMap((item) => {
                    if (item.value === null) {
                        return [
                            { label: `-- ${item.label} --`, value: null },
                            ...(item.subcategories || [])
                        ];
                    } else {
                        return item;
                    }
                });

                setCategoryOptions(options);
            } else {
                setCategoryOptions([]);
            }
        } else {
            setCategoryOptions([]);
        }
    };



    // Add or update variety
    const handleSubmit = async (e) => {
        e.preventDefault();


        if (!formData.image && !existingImage) {
            toast.error("Please choose an image");
            return;
        }

        const data = new FormData();
        data.append("collectionName", formData.collectionName);
        data.append("routeTo", formData.routeTo);
        data.append("image", formData.image || existingImage);
        data.append("placeTo", formData.placeTo);
        data.append("category", formData.category);
        data.append("startingFrom", formData.startingFrom);

        try {
            if (editingId) {
                await axios.put(`${backend_url}/api/designpatterns/${editingId}`, data);
                toast.success("Design Pattern Updated Successfully")
            } else {
                await axios.post(`${backend_url}/api/designpatterns`, data);
                toast.success("Design Pattern Added Successfully")
            }
            fetchDesignPatterns();
            closeModal();
        } catch (error) {
            console.error("Error saving designpatterns:", error);
            toast.error(error.response?.data?.error || "Error saving design pattern");
        }
    };

    // Handle edit
    // const handleEdit = (designpatterns) => {
    //     setFormData({
    //         collectionName: designpatterns.collectionName,
    //         routeTo: designpatterns.routeTo,
    //         image: designpatterns.image,
    //         placeTo: designpatterns.placeTo,
    //         category: designpatterns.category,
    //         startingFrom: designpatterns.startingFrom,
    //     });
    //     setSelectedCategory(designpatterns.category);

    //     // Filter routes for the selected category when editing
    //     const filteredRoutes = menuItems.find(
    //         (item) => item.value === designpatterns.category
    //     )?.routes || [];
    //     setCategoryOptions(filteredRoutes);

    //     setEditingId(designpatterns._id);
    //     setShowModal(true);
    // };

    const handleEdit = (designpatterns) => {
        setFormData({
            collectionName: designpatterns.collectionName,
            routeTo: designpatterns.routeTo,
            image: null, // Don't pre-fill the file, keep it null
            placeTo: designpatterns.placeTo,
            category: designpatterns.category,
            startingFrom: designpatterns.startingFrom,
        });
        setExistingImage(designpatterns.image || "");

        setSelectedCategory(designpatterns.category);

        // Populate the dropdown options correctly
        const selectedCategory = menuItems.find(
            (item) => item.value === designpatterns.category
        );

        if (selectedCategory && selectedCategory.dropdown) {
            const options = selectedCategory.dropdown.flatMap((item) =>
                item.value === null
                    ? [
                        { label: `-- ${item.label} --`, value: null },
                        ...(item.subcategories || []),
                    ]
                    : item
            );
            setCategoryOptions(options);
        } else {
            setCategoryOptions([]);
        }

        setEditingId(designpatterns._id);
        setShowModal(true);
    };


    // Handle delete
    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this designpatterns?")) {
            try {
                await axios.delete(`${backend_url}/api/designpatterns/${id}`);
                fetchDesignPatterns();
            } catch (error) {
                console.error("Error deleting designpatterns:", error);
            }
        }
    };

    const formatText = (text) =>
        text.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

    // Close modal and reset form
    const closeModal = () => {
        setShowModal(false);
        setEditingId(null);
        setFormData({ collectionName: "", routeTo: "", startingFrom: "", image: null, placeTo: "", category: "" });
        setSelectedCategory("");
        setCategoryOptions([]);
        setExistingImage("");
    };


    return (
        <>
            <div className="variety-admin">
                <div className="headerSections">
                    <div className="head-title">Design Patterns</div>
                    <button className="add-btn" onClick={() => setShowModal(true)}>
                        + Add Design Pattern
                    </button>
                </div>
                {/* Popup Modal */}
                {showModal && (
                    <div className="modal-overlay" onClick={closeModal}>
                        <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "800px" }}>
                            <h2>{editingId ? "Edit Design Pattern" : "Add Design Pattern"}</h2>
                            <form onSubmit={handleSubmit} className="variety-form">
                                <div className="form-row" style={{ display: 'flex', gap: '1rem' }}>
                                    <div className="form-group" style={{ flex: 1 }}>
                                        <label htmlFor="collectionName">Collection Name</label>
                                        <input
                                            type="text"
                                            id="collectionName"
                                            name="collectionName"
                                            value={formData.collectionName}
                                            onChange={handleChange}
                                            required
                                            maxLength={20}
                                        />
                                    </div>

                                    <div className="form-group" style={{ flex: 1 }}>
                                        <label htmlFor="startingFrom">Starting From (₹)</label>
                                        <input
                                            type="number"
                                            id="startingFrom"
                                            name="startingFrom"
                                            value={formData.startingFrom}
                                            onChange={handleChange}
                                            required
                                            maxLength={6} // Note: maxLength doesn't work on type="number"
                                        />
                                    </div>
                                </div>

                                <div className="form-row" style={{ display: 'flex', gap: '1rem' }}>
                                <div className="form-group" style={{ flex: 1 }}>
                                    <label htmlFor="category">Category</label>
                                    <select
                                        id="category"
                                        name="category"
                                        value={selectedCategory}
                                        onChange={handleCategoryChange}
                                        required
                                    >
                                        <option value="">Select a category</option>
                                        {menuItems.map((category) => (
                                            <option key={category.value} value={category.value}>
                                                {category.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Route To Dropdown */}
                                <div className="form-group" style={{ flex: 1 }}>
                                    <label htmlFor="routeTo">Route To</label>
                                    <select
                                        id="routeTo"
                                        name="routeTo"
                                        value={formData.routeTo}
                                        onChange={handleChange}
                                        required
                                        disabled={!selectedCategory}
                                    >
                                        <option value="">Select a route</option>
                                        {categoryOptions.map((option) =>
                                            option.value ? (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ) : (
                                                <option key={option.label} value="" disabled>
                                                    {option.label}
                                                </option>
                                            )
                                        )}
                                    </select>
                                </div>
                                </div>
                                {/* <div className="form-group">
                                    <label htmlFor="image">Image</label>
                                    <input
                                        type="file"
                                        id="image"
                                        name="image"
                                        onChange={handleChange}
                                        accept="image/*"
                                        required={!editingId}
                                    />
                                </div> */}

                                <div className="form-row" style={{ display: 'flex', gap: '1rem' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <MediaField
                                        id="image"
                                        label="Image"
                                        file={formData.image}
                                        existingUrl={existingImage}
                                        maxMB={MAX_IMAGE_MB}
                                        onFileSelect={(file) => setFormData({ ...formData, image: file })}
                                    />
                                </div>

                                <div className="form-group" style={{ flex: 1 }}>
                                    <label htmlFor="placeTo">Place To</label>
                                    <select
                                        id="placeTo"
                                        name="placeTo"
                                        value={formData.placeTo}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select a place</option>
                                        {availablePlaces.map((place) => (
                                            <option key={place} value={place}>
                                                {place}
                                            </option>
                                        ))}
                                    </select>
                                    </div>
                                   
                                </div>
                                 {formData.placeTo && (
                                        <div className="place-design-preview">
                                            <img
                                                src={placeImages[formData.placeTo]}
                                                alt={formData.placeTo}
                                            />
                                        </div>
                                    )}
                                <div className="form-buttons">
                                    <button type="submit" className="submit-btn">
                                        {editingId ? "Update" : "Add"}
                                    </button>
                                    <button type="button" onClick={closeModal} className="cancel-btn">
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {/* List Table */}
                <table className="variety-table">
                    <thead>
                        <tr>
                            <th>Collection Name</th>
                            <th>Category</th>
                            <th>Starting From</th>
                            <th>Route To</th>
                            <th>Image</th>
                            <th>Place To</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {designPatterns.map((designpattern) => (
                            <tr key={designpattern._id}>
                                <td>{designpattern.collectionName}</td>
                                <td>{formatText(designpattern.category)}</td>
                                <td>₹{designpattern.startingFrom}</td>
                                <td>{formatText(designpattern.routeTo)}</td>
                                <td>
                                    <div className="media-cell">
                                        <img src={designpattern.image} alt={designpattern.collectionName} />
                                        <DownloadButton url={designpattern.image} />
                                    </div>
                                </td>
                                <td>{designpattern.placeTo}</td>
                                <td>
                                    <button onClick={() => handleEdit(designpattern)}>Edit</button>
                                    {/* <button onClick={() => handleDelete(designpattern._id)}>Delete</button> */}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <ToastContainer />
        </>
    );
};

export default DesignPatterns;
